/* eslint-disable */
// custom debugger
import Debugger from "@/config/debugger";
const debug = new Debugger("views/Auth/controller.js", false);

// auth functions imported as Mixin at Auth.vue and App.vue
import { firebaseApp } from "@/config/firebase"
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const db = firebase.firestore(firebaseApp);
const userRef = db.collection("users");

export default {
    newUserObj: {

    },
    signIn(userObj) {
        const _this = this;
        let email = userObj.Email
        let password = userObj.Password
        return firebase.auth().signInWithEmailAndPassword(email, password).then((user) => {
            debug.log('_signedIn', user)
        }).catch(function (error) {
            // Handle Errors here.
            // var errorCode = error.code;
            // var errorMessage = error.message;
            console.log('error', error)
        });

    },
    registerUser(userObj) {
        const _this = this;
        return firebase.auth().createUserWithEmailAndPassword(userObj.Email, userObj.Password).then((data) => {
            console.log(data.user, data.user.uid)
            // userData returned user data from Firebase
            let userData = data.user;
            // newUserData combines the registration form info contact with returned firebase userData
            // this will be data saved to profile
            let newUserData = {
                uid: userData.uid,
                First_Name: userObj.First_Name,
                Last_Name: userObj.Last_Name,
                Email: userObj.Email,
                Terms: false,
                creationTime: userData.metadata.creationTime,
                providerData: userData.providerData[0].providerId,
                Role: _this.defaultRole(),
            }
            _this._addContactToDB(newUserData)

        }).catch(function (error) {
            // Handle Errors here.
            // var errorCode = error.code;
            // var errorMessage = error.message;
            debug.log.log(error)

        });

    },
    addContactToDB(userObj) {

        const _this = this;
        let successMsg = "Contact has been successfully added"

        if (userObj.uid) {
            successMsg = "Registration Success"
        }

        userRef.add(userObj).then((docRef) => {
            debug.log('_addUser', docRef, userObj)

            _this.appAlert({ color: 'success', message: successMsg })

        }).catch(function (error) {
            // Handle Errors here.
            // var errorCode = error.code;
            // var errorMessage = error.message;
            debug.log('_addNewUserProfile error', error)

        });
    },
    updateUser() {
        //TODO 
    },
    getUserData(user) {
        // gets user profile data from database
        const _this = this;
        let userData = ""
        return userRef.where("uid", "==", user.uid)
            .get().then(function (querySnapshot) {
                querySnapshot.forEach((doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    userData = doc.data();
                    userData.profileId = doc.id;
                    userData.signedIn = true;
                    this.$root.app.user = userData;
                });
                return userData;
            })
            .catch(function (error) {
                console.log("Error getting documents: ", error);
            });

    },
    signOut() {
        return firebase.auth().signOut().then(() => {
            // Sign-out successful.
            this.resetAppUser();
            console.log("user signedOut");
            return true

        }).catch(function (error) {

            return false
            console.log("sign-out error", error);
            // An error happened.
        });
    },
    resetAppUser() {
        //TODO this should be extended which includes signing out
        this.$root.app.user = { signedIn: false };
    },
    resetPassword(userObj) {
        var auth = firebase.auth();
        let email = userObj.Email;
        var emailAddress = email;
        return auth.sendPasswordResetEmail(emailAddress).then(function () {
            // Email sent.
            resolve('Email Sent')
        }).catch(function (error) {
            // An error happened.
            reject(error)
        });
    }
}
/* eslint-enable no-unused-vars */